module.exports = __webpack_public_path__ + "ubuntu-medium-webfont.e4344df114925f052a64.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ubuntu/ubuntu-medium-webfont.woff2
// module id = ./src/assets/webfonts/ubuntu/ubuntu-medium-webfont.woff2
// module chunks = styles